import {
  defaultFilterValue,
  policyTypes,
  policyOwnerTypes,
  paginationDefault,
} from './constants';

/**
 * @deprecated This should be removed once removing policyOwnerTypeOptions.
 */
const makeOptions = (optionsObject) =>
  Object.values(optionsObject).map((label) => ({ value: label, label }));

/**
 * @deprecated Prefer using in-place constants instead of this function.
 */
export const policyOwnerTypeOptions = makeOptions(policyOwnerTypes);

export const policyTypeOptions = {
  [policyTypes.lrp]: 'Livestock Risk Protection',
  [policyTypes.lgm]: 'Livestock Gross Margin',
};

export const pageSizeOptions = [...Array(3)].map((_val, index) =>
  index ? index * 3 * paginationDefault.pageSize : paginationDefault.pageSize
);
